import SectionTitle from '../common/SectionTitle';
import {CheckCircle} from 'lucide-react';
const WhyFloretTown = () => {
  const reasons = [
    'Thoughtfully designed for balanced, comfortable, and fulfilling lifestyle',
    'Built on core pillars of Green Living, Fresh Environment, and Blooming Community',
    'Emphasizes open green spaces and naturally refreshing atmosphere',
    'Premium villas with practical layouts and quality construction',
    'Community designed to encourage togetherness and celebrations',
    'Well-connected location close to essential amenities',
    'Promising choice for long-term investment with future growth potential',
    'Secure, planned infrastructure ensuring peace and privacy'
  ];

  return (
    <section className="py-10 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionTitle 
          title="Why Choose Floret Town?"
          subtitle="More than just a house — a well-planned lifestyle"
        />

        <div className="grid md:grid-cols-2 gap-4 mt-10">
          {reasons.map((reason, idx) => (
            <div key={idx} className="flex items-start space-x-4 p-6 bg-gray-50 rounded-xl shadow-md hover:shadow-xl hover:bg-emerald-50 transition-colors">
              <CheckCircle className="text-emerald-600 flex-shrink-0 mt-1" size={24} />
              <p className="text-gray-700 text-lg">{reason}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
export default WhyFloretTown;